import { ReactNode } from 'react';

import { Button } from 'components/Blocks';
import { CheckIcon, CopyIcon, WarningIcon } from 'components/Icons';

import { detectWebView } from './detectWebView';

import { useCopyToClipboard, useToggleV2 } from 'hooks';

export function WebviewGuard({ children }: { children: ReactNode }) {
  const [copied, { turnOff, turnOn }] = useToggleV2();

  const [copyToClipboard] = useCopyToClipboard();

  if (!detectWebView()) return <>{children}</>;

  const copy = () => {
    const fullUrl = `${location.origin}${location.pathname}${location.search}`;
    copyToClipboard(fullUrl);
    turnOn();

    setTimeout(turnOff, 4_000);
  };

  return (
    <div className="flex h-screen items-center justify-center px-5">
      <div className="flex flex-col items-center justify-center gap-4">
        <WarningIcon size={70} color="primary" />

        <h2 className="my-4 text-center text-[34px] leading-10">WebView Detected</h2>

        <p>It looks like an app opened OW Ops instead of your default browser.</p>

        <p>Copy the url and paste it on your browser of choice</p>

        <Button
          onClick={copy}
          disabled={copied}
          color={copied ? 'primary' : 'success'}
          className="w-32"
        >
          {copied ? <CheckIcon /> : <CopyIcon />}
          {copied ? 'Copied!' : 'Copy link'}
        </Button>
      </div>
    </div>
  );
}
